import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useSite } from "@/context/SiteContext";
import { Header } from "./IndustriesPanel";

export default function TagsPanel() {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const site = useSite();

  const load = async () => {
    try {
      const { data } = await api.get("/admin/tags");
      setItems(data);
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    try {
      await api.post("/admin/tags", { name: name.trim() });
      setName("");
      await load();
      await site.reload();
      toast.success("Tag added.");
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Delete this tag?")) return;
    try {
      await api.delete(`/admin/tags/${id}`);
      await load();
      await site.reload();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  return (
    <div data-testid="tags-panel" className="space-y-6">
      <Header title="Tags" subtitle="Free-form labels attached to features (e.g. ANPR, Bengali, Edge)." />
      <form onSubmit={add} className="flex gap-2 max-w-xl">
        <Input
          data-testid="tag-input-name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="e.g. Drone Detection"
        />
        <Button data-testid="tag-add" type="submit" className="bg-brand text-white hover:bg-brand-dark font-semibold">
          Add tag
        </Button>
      </form>
      <div className="flex flex-wrap gap-2 bg-white border border-neutral-200 rounded-xl p-4">
        {items.length === 0 && <p className="text-sm text-neutral-500">No tags yet.</p>}
        {items.map((t) => (
          <button
            key={t.id}
            type="button"
            data-testid={`tag-chip-${t.slug}`}
            onClick={() => remove(t.id)}
            title="Click to delete"
            className="text-xs font-medium px-3 py-1.5 rounded-full bg-neutral-100 text-neutral-700 border border-neutral-200 hover:border-red-400 hover:text-red-600 transition-colors"
          >
            {t.name} <span className="text-neutral-400 ml-1">×</span>
          </button>
        ))}
      </div>
    </div>
  );
}
